import React from 'react';
import KycRequirements from './kyc-requirements';
export default function PayrollAccountDetails() {
  return /*#__PURE__*/React.createElement(KycRequirements, {
    label: "Payroll Account Details",
    icon: "Bank",
    list: ['Bank Name', 'Account Name', 'Account Number']
  });
}
//# sourceMappingURL=payroll-account-details.js.map